










































import Vue from 'vue'
import { defaultPosterImage, defaultAssessmentImage } from '@/helper/constants'

export default Vue.extend({
  props: {
    post: {
      type: Object,
      required: true
    },
    nextLesson: {
      type: Object
    }
  },
  data() {
    return {
      defaultPosterImage
    }
  },
  computed: {
    nextLessonContent(): string {
      return this?.nextLesson?.content || 'Awesome! Continue Pushing!'
    },
    posterImage(): string {
      const contentWiseDefaultImage = this.post.contentType === 'quiz' ? defaultAssessmentImage : defaultPosterImage
      return this.post.posterImage || contentWiseDefaultImage
    },
  }
})
